import RoundTab from "components/RoundTabButtons/RoundTab";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Modal, ModalBody } from "reactstrap";
import { HorizontalLineDivider } from "styledComponents/Activity";
import {
  BorderButtonWithIcon,
  ButtonIcon,
  ConfirmButton,
} from "styledComponents/buttons";
import { CrossIcon } from "styledComponents/createProject";
import { RedStar } from "styledComponents/members";

import deleteIcon from "../../../assets/img/icons/delete-3.svg";
import deleteWhiteIcon from "../../../assets/img/icons/delete_white.svg";
import Plus from "../../../assets/img/icons/plus_primary.svg";
import FilterDropDownStyle from "../../../components/DropdownStyle/FilterDropDownStyle";
import Select from "../../../components/ReactSelectDropdown";
import { DeleteButton } from "../../../styledComponents/buttons";
import {
  GeneralInfoItem,
  GeneralInfoSection2,
  HoveredSectionClient,
} from "../../../styledComponents/clients";
import {
  CardTitle,
  CommonFlex,
  CommonGrid,
  CommonText,
  Container,
  ContainerWithColor,
  ContentHeader,
  DividerLine,
  FormAlert,
  InputField,
  InputLabel,
  InputSection,
  InputTextArea,
  InputWithLabelSection,
  ManagerBadge,
  PageTitle,
} from "../../../styledComponents/common";
import { CommonImage } from "../../../styledComponents/common";
import { checkHtml, checkUrl, validateEmail } from "../../../utils/helper";
import AddLocationModal from "../../ClientsNew/ClientDetails/AddLocationModal";

const CreateProjectModal = ({
  isOpen,
  toggle,
  selectedOrganization,
  clientShortList,
  getClientList,
  getClientShortList,
  clearCreatedCustomerInfo,
  createClient,
  createdClientId,
  createdClientInfo,
  createWorkOrderRequest,
  createdWorkOrderId,
  createWorkOrderIsLoading,
  clearWorkOrderId,
  onProjectCreated,
}) => {
  const { t } = useTranslation();
  const workOrderInputRef = useRef(null);
  const [saveErrors, setSaveErrors] = useState({});
  const [workOrderName, setWorkOrderName] = useState("");
  const [selectedClient, setSelectedClient] = useState(null);
  const [clientOptions, setClientOptions] = useState([]);
  const [status, setStatus] = useState({ value: "open", label: "Open" });
  const [clientName, setClientName] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [customerSaveErrors, setCustomerSaveErrors] = useState({});
  const [isCustomerFormOpen, setIsCustomerFormOpen] = useState(false);
  const [clientLocationList, setClientLocationList] = useState([]);
  const [hoveredId, setHoveredId] = useState(null);
  const [popupOpen, setPopupOpen] = useState(false);
  const customerInputRef = useRef(null);
  const lastSubmittedProject = useRef(null);
  // Dynamic labels based on organization type (default to "operation" if not defined)
  const orgType = selectedOrganization?.type || "operation";

  const handleToggle = () => {
    toggle();
  };

  const onStatusSelect = e => {
    setStatus(e);
  };

  const statusOptions = [
    { value: "open", label: "Open" },
    { value: "in progress", label: "In Progress" },
    { value: "complete", label: "Complete" },
  ];

  const onWorkOrderNameChange = e => {
    const { value } = e.target;
    setWorkOrderName(value);
    if (saveErrors && saveErrors["workOrderName"]) {
      const errors = { ...saveErrors };
      delete errors["workOrderName"];
      setSaveErrors(errors);
    }
  };

  const onClientSelect = e => {
    setSelectedClient(e);
    if (saveErrors && saveErrors["selectedClient"]) {
      const errors = { ...saveErrors };
      delete errors["selectedClient"];
      setSaveErrors(errors);
    }
  };

  const onEmailChange = e => {
    const { value } = e.target;
    setClientEmail(value);
    if (customerSaveErrors && customerSaveErrors["clientEmail"]) {
      const errors = { ...customerSaveErrors };
      delete errors["clientEmail"];
      setCustomerSaveErrors(errors);
    }
  };
  const onHoverChange = id => {
    setHoveredId(id);
  };

  const addLocationToggle = () => {
    setPopupOpen(!popupOpen);
  };

  const handleClientLocation = locationData => {
    // Add new location with temporary ID
    const newLocation = {
      ...locationData,
      tempId: Date.now() + Math.random(),
      default: locationData.default || false,
    };

    // If new location is default, remove default from all existing locations
    const updatedList = clientLocationList.map(loc => ({
      ...loc,
      default: newLocation.default ? false : loc.default,
    }));

    setClientLocationList([...updatedList, newLocation]);
    setPopupOpen(false);
  };

  const handleClientLocationDelete = index => {
    const updatedList = clientLocationList.filter((_, i) => i !== index);
    setClientLocationList(updatedList);
  };
  const onClientNameChange = e => {
    const { value } = e.target;
    setClientName(value);
    if (customerSaveErrors && customerSaveErrors["clientName"]) {
      const errors = { ...customerSaveErrors };
      delete errors["clientName"];
      setCustomerSaveErrors(errors);
    }
  };

  const checkCustomerError = () => {
    let errors = {};
    let formIsValid = true;
    if (!clientName.trim()) {
      formIsValid = false;
      errors["clientName"] = t("please_enter_customer_name");
    } else if (clientName.length > 256) {
      formIsValid = false;
      errors["clientName"] = t(
        "please_enter_customer_name_within_256_characters",
      );
    } else if (checkUrl(clientName)) {
      formIsValid = false;
      errors["clientName"] = t("client_name_can_not_contain_url");
    } else if (checkHtml(clientName)) {
      formIsValid = false;
      errors["clientName"] = t("invalid_client_name");
    }
    if (!validateEmail(clientEmail)) {
      formIsValid = false;
      errors["clientEmail"] = t("please_enter_a_valid_email_address");
    }
    setCustomerSaveErrors(errors);
    return formIsValid;
  };

  const handleCustomerSave = () => {
    if (checkCustomerError()) {
      if (selectedOrganization && selectedOrganization.id) {
        let payload = {
          organization_id: selectedOrganization.id,
          name: clientName,
          // phone_number: phoneNumber ? phoneNumber : null,
          phone_number: phoneNumber
            ? phoneNumber.startsWith("+")
              ? phoneNumber
              : "+" + phoneNumber
            : null,
          email: clientEmail ? clientEmail : null,
          location_list: clientLocationList,
          // office_location: officeLocation ? officeLocation : null,
        };
        createClient(payload);
      }
    }
  };

  const checkProjectError = () => {
    let errors = {};
    let formIsValid = true;

    if (!workOrderName.trim()) {
      formIsValid = false;
      errors["workOrderName"] = t(
        orgType === "service"
          ? "job_name_is_required"
          : "project_name_is_required",
      );
    } else if (checkUrl(workOrderName)) {
      formIsValid = false;
      errors["workOrderName"] =
        orgType === "service"
          ? "Job name cannot contain url"
          : "Project name cannot contain url";
    } else if (checkHtml(workOrderName)) {
      formIsValid = false;
      errors["workOrderName"] =
        orgType === "service" ? "Invalid Job Name" : "Invalid Project Name";
    }

    // Customer is only required for service org type
    if (orgType !== "operation") {
      if (!selectedClient || !selectedClient.value) {
        formIsValid = false;
        errors["selectedClient"] =
          t("customer_is_required") || "Customer is required";
      }
    }

    setSaveErrors(errors);
    return formIsValid;
  };

  const handleConfirm = () => {
    if (checkProjectError() && !createWorkOrderIsLoading) {
      if (selectedOrganization && selectedOrganization.id) {
        // Store the submitted values for use in success callback
        lastSubmittedProject.current = {
          name: workOrderName,
          client_id:
            orgType !== "operation" && selectedClient
              ? selectedClient.value
              : null,
          client_name:
            orgType !== "operation" && selectedClient
              ? selectedClient.label
              : null,
          location_list: clientLocationList,
        };
        let payload = {
          organization_id: selectedOrganization.id,
          name: workOrderName,
          status: status ? status.value : null,
          org_type: selectedOrganization.type,
        };
        // Only include client_id for service org type
        if (orgType !== "operation") {
          payload.client_id = selectedClient ? selectedClient.value : null;
        }
        createWorkOrderRequest(payload);
      }
    }
  };

  useEffect(() => {
    return () => {
      clearCreatedCustomerInfo();
      clearWorkOrderId();
      // Reset form when modal closes
      setWorkOrderName("");
      setSelectedClient(null);
      setStatus({ value: "open", label: "Open" });
      setSaveErrors({});
      setIsCustomerFormOpen(false);
      setClientName("");
      setClientEmail("");
      setPhoneNumber("");
      setCustomerSaveErrors({});
      lastSubmittedProject.current = null;
    };
  }, []);

  // Reset form when modal opens
  useEffect(() => {
    if (isOpen) {
      setWorkOrderName("");
      setSelectedClient(null);
      setStatus({ value: "open", label: "Open" });
      setSaveErrors({});
      setIsCustomerFormOpen(false);
      setClientName("");
      setClientEmail("");
      setPhoneNumber("");
      setCustomerSaveErrors({});
      if (workOrderInputRef.current) {
        workOrderInputRef.current.focus();
      }
    }
  }, [isOpen]);

  //useEffect to get client short list
  useEffect(() => {
    if (clientShortList && clientShortList.length > 0) {
      const options = [];
      clientShortList
        .filter(item => item.is_active)
        .map(item => {
          options.push({
            value: item.id,
            label: item.name,
          });
        });
      options.unshift({ label: "Select Customer", value: "" });
      setClientOptions(options);
    } else if (clientShortList && clientShortList.length === 0) {
      setClientOptions([]);
    }
  }, [clientShortList]);

  useEffect(() => {
    if (isOpen) {
      getClientList({ organization_id: selectedOrganization.id });
      getClientShortList({ organization_id: selectedOrganization.id });
      setClientLocationList([]); // reset locations when modal opens
      setHoveredId(null);
    }
  }, [isOpen]);

  // Handle successful client creation
  useEffect(() => {
    if (createdClientId !== null && createdClientInfo && createdClientInfo.id) {
      // Select the newly created client
      setSelectedClient({
        value: createdClientInfo.id,
        label: createdClientInfo.name,
      });
      // Reset form fields
      setClientName("");
      setClientEmail("");
      setPhoneNumber("");
      setCustomerSaveErrors({});
      // Close the customer form
      setIsCustomerFormOpen(false);
      // Clear the created client info
      clearCreatedCustomerInfo();
    }
  }, [createdClientId, createdClientInfo]);

  // Handle successful work order/project creation
  useEffect(() => {
    if (createdWorkOrderId !== null && isOpen && lastSubmittedProject.current) {
      // Notify parent component about the created project
      // Use the stored submitted values along with the ID from Redux
      if (onProjectCreated) {
        onProjectCreated({
          id: createdWorkOrderId,
          name: lastSubmittedProject.current.name,
          client_id: lastSubmittedProject.current.client_id,
          client_name: lastSubmittedProject.current.client_name,
        });
      }
      // Clear the stored values
      lastSubmittedProject.current = null;
      // Close modal
      toggle();
      // Clear the created work order info
      clearWorkOrderId();
    }
  }, [createdWorkOrderId, isOpen, onProjectCreated, toggle, clearWorkOrderId]);

  return (
    <Modal isOpen={isOpen} toggle={handleToggle} style={{ height: "auto" }}>
      <ModalBody>
        <CardTitle>
          {t(orgType === "service" ? "add_job_details" : "add_project_details")}
        </CardTitle>
        {orgType !== "operation" && (
          <AddLocationModal
            isOpen={popupOpen}
            toggle={addLocationToggle}
            addClientLocation={handleClientLocation}
            organization_id={selectedOrganization.id}
            action="add"
          />
        )}
        <CommonGrid columns="1fr">
          {/* Job/Project Creation section */}
          <div>
            <InputSection>
              <InputLabel style={{ marginBottom: "10px" }}>
                {t(orgType === "service" ? "job" : "project")}{" "}
                <RedStar>*</RedStar>
              </InputLabel>
              <InputField
                marginTop="10px"
                width="100%"
                type="text"
                ref={workOrderInputRef}
                placeholder={
                  orgType === "service" ? "Type Job" : "Type Project"
                }
                value={workOrderName}
                onChange={e => onWorkOrderNameChange(e)}
                error={
                  saveErrors &&
                  saveErrors["workOrderName"] &&
                  saveErrors["workOrderName"] !== undefined
                }
              />
              {saveErrors &&
                saveErrors["workOrderName"] &&
                saveErrors["workOrderName"] !== undefined && (
                  <FormAlert margin="0 0 0 5px">
                    {saveErrors["workOrderName"]}
                  </FormAlert>
                )}
            </InputSection>

            <InputSection>
              <InputLabel style={{ marginBottom: "10px" }}>
                {t("status")}
              </InputLabel>
              <CommonGrid
                columns="auto auto auto"
                justifyContent="flex-start"
                gap="8px"
              >
                {statusOptions.map(option => (
                  <RoundTab
                    key={option.value}
                    text={option.label}
                    selected={status.value === option.value}
                    onClick={() => onStatusSelect(option)}
                  />
                ))}
              </CommonGrid>
            </InputSection>
            <HorizontalLineDivider margin="15px 0" />

            {orgType !== "operation" && (
              <>
                <PageTitle fontSize="16px">Customer details</PageTitle>

                <InputSection>
                  <InputLabel style={{ marginBottom: "10px" }}>
                    {t("customer")} <RedStar>*</RedStar>
                  </InputLabel>
                  <Select
                    value={selectedClient}
                    options={clientOptions}
                    onChange={e => onClientSelect(e)}
                    placeholder="Select Customer..."
                    styles={FilterDropDownStyle({ height: "40px" })}
                  />
                </InputSection>
                {!isCustomerFormOpen &&
                  (!selectedClient ||
                    !selectedClient.value ||
                    selectedClient.value === "") && (
                    <BorderButtonWithIcon
                      borderRadius="30px"
                      margin="24px 0 0 0"
                      borderColor="#2266EF"
                      onClick={() => setIsCustomerFormOpen(true)}
                    >
                      <ButtonIcon src={Plus} alt="plus" />
                      Add New Customer
                    </BorderButtonWithIcon>
                  )}
                {isCustomerFormOpen && (
                  <ContainerWithColor margin="24px 0 0 0" bgColor="#EDF8FE">
                    <CommonGrid style={{ width: "100%" }} columns="1fr 1fr">
                      <PageTitle fontSize="16px">Add new customer</PageTitle>
                      <CommonFlex justifyContent="flex-end">
                        <CrossIcon
                          src={deleteIcon}
                          alt="delete"
                          onClick={() => setIsCustomerFormOpen(false)}
                          style={{ cursor: "pointer" }}
                        />
                      </CommonFlex>
                    </CommonGrid>
                    <CommonGrid
                      gap="16px"
                      style={{ width: "100%" }}
                      columns="1fr"
                    >
                      <InputWithLabelSection>
                        <InputLabel>
                          {t("customer_name")} <RedStar>*</RedStar>
                        </InputLabel>
                        <InputField
                          type="text"
                          placeholder={t("type_customer_name_here")}
                          ref={customerInputRef}
                          value={clientName}
                          onChange={e => onClientNameChange(e)}
                          error={
                            customerSaveErrors &&
                            customerSaveErrors["clientName"] &&
                            customerSaveErrors["clientName"] !== undefined
                          }
                        />
                        {customerSaveErrors &&
                          customerSaveErrors["clientName"] &&
                          customerSaveErrors["clientName"] !== undefined && (
                            <FormAlert margin="0 0 0 5px">
                              {customerSaveErrors["clientName"]}
                            </FormAlert>
                          )}
                      </InputWithLabelSection>
                      <InputWithLabelSection>
                        <InputLabel>
                          {t("email_address")} <RedStar>*</RedStar>
                        </InputLabel>
                        <InputField
                          type="text"
                          placeholder={t("type_email_address_here")}
                          value={clientEmail}
                          onChange={e => onEmailChange(e)}
                          error={
                            customerSaveErrors &&
                            customerSaveErrors["clientEmail"] &&
                            customerSaveErrors["clientEmail"] !== undefined
                          }
                        />
                        {customerSaveErrors &&
                          customerSaveErrors["clientEmail"] &&
                          customerSaveErrors["clientEmail"] !== undefined && (
                            <FormAlert margin="0 0 0 5px">
                              {customerSaveErrors["clientEmail"]}
                            </FormAlert>
                          )}
                      </InputWithLabelSection>
                      <InputWithLabelSection>
                        <InputLabel>{t("contact_number")}</InputLabel>
                        <PhoneInput
                          enableSearch
                          country={"us"}
                          value={phoneNumber}
                          onChange={phone => setPhoneNumber(phone)}
                          inputClass="phone-number-input"
                          buttonClass="phone-number-flag-dropdown"
                        />
                      </InputWithLabelSection>
                      <InputWithLabelSection>
                        <InputLabel>{t("location")}</InputLabel>
                        <CommonFlex justifyContent="flex-start">
                          <BorderButtonWithIcon
                            borderRadius="30px"
                            margin="0"
                            borderColor="#2266EF"
                            onClick={() => addLocationToggle()}
                          >
                            <ButtonIcon src={Plus} alt="plus" />
                            {clientLocationList?.length >= 1
                              ? t("add_more_location")
                              : t("add_location")}
                          </BorderButtonWithIcon>
                        </CommonFlex>
                      </InputWithLabelSection>

                      {clientLocationList && clientLocationList.length > 0 && (
                        <GeneralInfoSection2
                          style={{ marginTop: "10px", minWidth: "200px" }}
                        >
                          {clientLocationList.map((item, index) => (
                            <div
                              key={index}
                              onMouseEnter={() => onHoverChange(index)}
                              onMouseLeave={() => onHoverChange(null)}
                              style={{
                                position: "relative",
                                zIndex: hoveredId === index ? 1 : "auto",
                                width: "fit-content",
                              }}
                            >
                              <CommonText $label>
                                {t("service_location")} {index + 1}{" "}
                                {item.default ? `(${t("default")})` : ""}
                              </CommonText>

                              <div
                                style={{
                                  paddingBottom: "10px",
                                  paddingTop: "10px",
                                  cursor: "pointer",
                                  width: "200px",
                                  position: "relative",
                                }}
                              >
                                {hoveredId !== null && hoveredId === index ? (
                                  <HoveredSectionClient>
                                    {/* <DeleteButton
                                      onClick={() =>
                                        handleClientLocationDelete(index)
                                      }
                                    > */}
                                    <CommonImage
                                      src={deleteWhiteIcon}
                                      alt=""
                                      size="16px"
                                      onClick={() =>
                                        handleClientLocationDelete(index)
                                      }
                                    />
                                    {/* </DeleteButton> */}
                                  </HoveredSectionClient>
                                ) : null}
                                <GeneralInfoItem
                                  minHeight="130px"
                                  backColor={(index + 3) % 8}
                                >
                                  <CommonText title>{item.address}</CommonText>
                                  <CommonText $label fontWeight="500">
                                    {item.name}
                                  </CommonText>
                                </GeneralInfoItem>
                              </div>
                            </div>
                          ))}
                        </GeneralInfoSection2>
                      )}

                      <ConfirmButton
                        width="40%"
                        borderRadius="30px"
                        bgColor="#6C2EF2"
                        onClick={handleCustomerSave}
                      >
                        Save Customer
                      </ConfirmButton>
                    </CommonGrid>
                  </ContainerWithColor>
                )}
              </>
            )}

            <ConfirmButton
              borderRadius="30px"
              margin="24px 0 0 0"
              padding="0 25px 0 15px"
              width="100%"
              onClick={handleConfirm}
              disabled={createWorkOrderIsLoading}
            >
              {createWorkOrderIsLoading ? "Creating..." : "Confirm"}
            </ConfirmButton>
          </div>
        </CommonGrid>
      </ModalBody>
    </Modal>
  );
};

export default CreateProjectModal;
